import styled from "@emotion/styled";

export const StyleWrapper = styled.div`
  position: relative;
  display: inline-block;

  &:hover > div {
    display: flex;
  }
`;

export const CurrentStyleButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.25rem 0.5rem;
  background-color: transparent;
  border: 0.0625rem solid transparent;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.2s ease;
  justify-content: center;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const StyleDropdown = styled.div`
  display: none;
  position: absolute;
  top: 100%;
  right: 0;
  padding-top: 0.5rem;
  flex-direction: column;
  min-width: 7rem;
  z-index: 100;

  & > div {
    background-color: ${({ theme }) => theme.colors.surface};
    border: 0.0625rem solid ${({ theme }) => theme.colors.border};
    border-radius: ${({ theme }) => theme.borderRadius.md};
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1);
    padding: 0.25rem;
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
  }
`;

export const StyleOption = styled.button<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  background-color: ${({ isActive, theme }) =>
    isActive ? theme.colors.background : "transparent"};
  color: ${({ isActive, theme }) =>
    isActive ? theme.colors.primary : theme.colors.text};
  border: none;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  font-size: 0.75rem;
  font-weight: ${({ isActive }) => (isActive ? "600" : "400")};
  cursor: pointer;
  text-align: left;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background};
    color: ${({ theme }) => theme.colors.primary};
  }
`;
